import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useNetwork } from '@mantine/hooks';
import { injectIntl } from 'react-intl';

import { SVGIcon } from '@superops/super-icons';
import { TextStyle } from '@superops/ui-design-system';

import { getTranslatedText } from '@nile/components';

let broadcastChannel;

if (BroadcastChannel) {
  broadcastChannel = new BroadcastChannel('SuperShare');
}

function AppNetworkStatus({ intl, flags }) {
  const networkStatus = useNetwork();

  const toastId = React.useRef(null);

  const notify = () =>
    (toastId.current = toast(
      <div className="fx g10">
        <SVGIcon name="CircleCancelMinor" color="red" />
        <span className="mr-20">
          <TextStyle>
            {getTranslatedText(intl, 'mobile.message.onNetworkDisconnected')}
          </TextStyle>
        </span>
      </div>,
      {
        position: 'top-center',
        className: 'Sops-network-status',
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        closeButton: false
      }
    ));

  const dismiss = () => toast.dismiss(toastId.current);

  useEffect(() => {
    if (networkStatus.online) {
      dismiss();
    } else {
      if (flags.networkstatusForApp) {
        broadcastChannel.postMessage(
          JSON.stringify({
            name: 'close'
          })
        );
        notify();
      }
    }
  }, [networkStatus.online]);

  return <></>;
}

export default injectIntl(AppNetworkStatus);
